import React, { Component } from 'react'
import { Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import WinnerSheep from './winnerSheep/view'

import Levels from 'react-activity/lib/Levels'
import 'react-activity/lib/Levels/Levels.css'
import { getGameSummary } from '../../../src/entities/game/actions'

// Styles
import './styles/thankyouWindowStyles.css'
import '../questionsWindow/styles/questionsWindow.css'
import '../../../src/styles/styles.css'

import endBanner from '../../../src/assets/endBanner.png'

class ThankyouWindow extends Component {
  constructor () {
    super()

    this.state = {
      players: [],
      isLoading: true,
    }
  }

  componentDidMount () {
    const { gameId } = this.props.params

    this.props.getGameSummary(gameId, (response) => {
      const { players } = response
      this.setState({
        isLoading: false,
        players,
      })
    })
  }

  renderWinners () {
    const { players } = this.state
    const length = players.length

    if (length === 0) {
      return (
        <div style={{ width: '100%' }}>
          <ReactCSSTransitionGroup
            transitionName="internalBox"
            transitionAppear={true}
            transitionAppearTimeout={500}
            transitionLeaveTimeout={500}
            transitionEnter={false}
          >
            <div className={'bgWhite internalBox flexCenter'}>
              <h3 className="fontFamilyBold fontColorGreen categoryName flexCenter">
                NO PLAYERS FINISHED THE GAME :(
              </h3>
            </div>
          </ReactCSSTransitionGroup>
        </div>
      )
    }
    return (
      <div style={{ width: '100%' }}>
        <ReactCSSTransitionGroup
          transitionName="internalBox"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionLeaveTimeout={500}
          transitionEnter={false}
        >
          <div className={'bgWhite internalBox'}>
            <Col xs={12} sm={6} lg={6} className="winnerCategory flexCenter flexColumn" style={{ paddingRight: 5 }}>
              <Col sm={12} className="flexCenter categoryContainer">
                <h3 className="fontFamilyBold fontColorGreen categoryName">
                  WHITE SHEEP
                </h3>
              </Col>
              <WinnerSheep player={players[0]} opacity={0}/>
              {length >= 2 && <WinnerSheep player={players[1]} opacity={.1} subtitle={'2nd position'} />}
              {length >= 3 && <WinnerSheep player={players[2]} opacity={.2} subtitle={'3rd position'} />}
            </Col>
            <Col xs={12} sm={6} lg={6} className="winnerCategory flexCenter flexColumn" style={{ paddingLeft: 5 }}>
              <Col sm={12} className="flexCenter categoryContainer">
                <h3 className="fontFamilyBold fontColorGreen categoryName">
                  BLACK SHEEP
                </h3>
              </Col>
              <WinnerSheep player={players[length - 1]} opacity={1} />
              {length >= 2 && <WinnerSheep player={players[length - 2]} opacity={.9} subtitle={'2nd position'} />}
              {length >= 3 && <WinnerSheep player={players[length - 3]} opacity={.8} subtitle={'3rd position'} />}
            </Col>
            <div className="clearfix"></div>
          </div>
        </ReactCSSTransitionGroup>
      </div>
    )
  }

  render () {
    const { isLoading } = this.state

    return (
      <div className="thankYouWindow">
        <div>
          <Col xs={12} sm={4} lg={6} className="leftBanner p0">
            <div className="thankyouContainer bgLightGray">
              <img alt="" src={endBanner} className="banner"></img>
            </div>
            <div className="socialMediaContainer bgLightGray">
              <div>
                <a
                  href="https://www.facebook.com/opiniontrivia"
                  className="fontFamilyBold socialIcon facebookIcon"
                >
                </a>
                <a
                  href="https://www.instagram.com/opiniontrivia/"
                  className="fontFamilyBold socialIcon instagramIcon"
                >
                  opiniontrivia
                </a>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={8} lg={6} className="rightBanner p0 flexCenter">
            {isLoading && <div className="textCenter">
              <h2>Counting Sheep</h2>
              <Levels color="#727981" size={102} speed={1} animating={true} />
              <p>Depending on the Flock, this could take a while</p>
            </div>}
            {!isLoading && this.renderWinners()}
          </Col>
        </div>
      </div>
    )
  }
}

export default connect(null, { getGameSummary })(ThankyouWindow)



// WEBPACK FOOTER //
// ./src/components/thankyouWindow/view.js